/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import {useMemo} from 'react'
import {UiSelectOption} from 'components/Ui/UiSelect'

export const companyPositionGroups: { groupLabel: string; options: UiSelectOption[] }[] = [
    {
        groupLabel: 'Firmen & Organisationen',
        options: [
            'Geschäftsführung / Inhaber',
            'GL-Mitglied / Kader',
            'GL-Assistenz / Eventmanagement',
            'Office-Management / Administration',
            'Teamleitung / Abteilungsleitung',
            'Teammitglied',
            'Lehrling',
        ].map((position) => ({ value: position, label: position })),
    },
    {
        groupLabel: 'Schulen & Bildung',
        options: ['Lehrperson', 'Schulleitung'].map((position) => ({ value: position, label: position })),
    },
    {
        groupLabel: 'Vereine',
        options: [{ value: 'Vereinsmitglied', label: 'Vereinsmitglied' }],
    },
    {
        groupLabel: 'Private Anlässe',
        options: [{ value: 'Privatperson', label: 'Privatperson' }],
    },
]

const defaultPositions = companyPositionGroups.flatMap((group) =>
    group.options.map((option) => String(option.value))
)

export const getCompanyPositionGroups = (otherLabel: string) => [
    ...companyPositionGroups,
    { groupLabel: '', options: [{ value: 'custom', label: otherLabel }] },
]

const useCompanyPositionOptions = (otherLabel: string) => {
    return useMemo<UiSelectOption[]>(() => {
        return [
            ...defaultPositions.map((pos) => ({ value: pos, label: pos })),
            { value: 'custom', label: otherLabel },
        ]
    }, [otherLabel])
}

export default useCompanyPositionOptions
export { defaultPositions }
